module.exports = __webpack_public_path__ + "img/instruct2.4e831312.png";